import postAPI from './postAPI.js'

export default async function postRotateActionSecret(actionId) {
    const data = await postAPI('admin/taskflows/actions/rotate-secret', { id: actionId });
    return data;
}
